import { EditorField } from "../../../src/components/EditorField";
import type BaseObject from "../../../src/models/BaseObject";
import { useOnChangeWatcher } from "../../../src/models/useOnChangeWatcher";
import { itx } from "../../../src/translationItx/itx";

/** Bearbeitet den persistierten Gerätenamen, nicht den Namen eines Kanals oder einer Definition. */
export function C1_EloNameField({ obj }: { obj: BaseObject | undefined }) {
  useOnChangeWatcher(obj);
  if (!obj) return null;
  return (
    <EditorField className="C1_eloNameField dockLabel" label={itx("c1.ui.Name", "Name")} htmlFor={`elo-name-${obj.id}`}>
      <input
        type="text"
        className="estada-editorControl dockControl"
        data-testid="c1-elo-name"
        id={`elo-name-${obj.id}`}
        value={obj.displayName}
        onChange={(event) => { obj.displayName = event.target.value; }}
        onBlur={() => globalThis.state.undoManager.userInteractionEnded()}
      />
    </EditorField>
  );
}
